// ↓ useBuildIns: usageなら regenerator-runtime/runtimeいらない
require('regenerator-runtime/runtime');
// IEサポート外になったらいらない
const nodeModulesEntryIncludes = ['typed-signals'].join('|');
module.exports = {nodeModulesEntryIncludes};
